module.exports = __webpack_public_path__ + "img/firmshift-logo.270cddd7.svg";